function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fine-type_svg__cls-1{fill:#fff;stroke:#1a1a1a;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "fine-type_svg___ppl"
}, /*#__PURE__*/React.createElement("path", {
  className: "fine-type_svg__cls-1",
  d: "M1 1h167.74v227.27H1z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "fine-type_svg__cls-1",
  cx: 84.31,
  cy: 34.34,
  r: 8.92
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.7 87.28H32.93m102.77-20H32.93m102.77 40H32.93m102.77 20H32.93m76.91 20H32.93m76.91 20H32.93",
  fill: "#1a1a1a",
  stroke: "#1a1a1a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgFineType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 169.74 229.27"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNjkuNzQgMjI5LjI3Ij48ZGVmcz48c3R5bGU+LmNscy0xLC5jbHMtMntmaWxsOiNmZmY7c3Ryb2tlOiMxYTFhMWE7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDoycHh9LmNscy0ye2ZpbGw6IzFhMWExYX08L3N0eWxlPjwvZGVmcz48ZyBpZD0iX3BwbCI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMSAxaDE2Ny43NHYyMjcuMjdIMXoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9Ijg0LjMxIiBjeT0iMzQuMzQiIHI9IjguOTIiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xMzUuNyA4Ny4yOEgzMi45M00xMzUuNyA2Ny4yOEgzMi45M00xMzUuNyAxMDcuMjhIMzIuOTNNMTM1LjcgMTI3LjI4SDMyLjkzTTEwOS44NCAxNDcuMjhIMzIuOTNNMTA5Ljg0IDE2Ny4yOEgzMi45MyIvPjwvZz48L3N2Zz4=";
export { SvgFineType as ReactComponent };